import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-592b9601"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sticky-column" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  class: "is-flex is-justify-content-start",
  style: {"gap":"1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("div", null, _toDisplayString(_ctx.formatSchedule(_ctx.appointmentData.schedule)), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.appointmentData.name), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.appointmentData.appointment_status), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.appointmentData.status_date), 1)
    ]),
    _createElementVNode("td", null, [
      (
        _ctx.appointmentData.appointment_status_key == 'TK_Confirmed' &&
        !_ctx.schedulePassed1Hour(_ctx.appointmentData.schedule)
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("a", {
              href: _ctx.generateAppointmentLink(_ctx.appointmentData.customer_pin),
              class: "pointer"
            }, _toDisplayString(_ctx.$t('AppointmentData.Link')), 9, _hoisted_3)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('AppointmentData.LinkNotAvailable')), 1))
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          type: "button",
          class: "button is-warning is-small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.iniAppointmentData(_ctx.appointmentData)))
        }, _toDisplayString(_ctx.$t('General.Details')), 1)
      ])
    ])
  ], 64))
}